import { createTheme } from '@material-ui/core';
import { color } from './color';
import typography, { font } from './typography';
import zIndex from './zIndex';

export const muiTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 544,
      md: 768,
      lg: 1012,
      xl: 1280,
    },
  },
  zIndex,
});

export default {
  mui: { ...muiTheme },
  typography,
  color,
  font,
};
